import React, { useState, useEffect } from 'react';

const BelongingReminderPage = ({ onContinue }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showContinue, setShowContinue] = useState(false);
  const [iq, setIq] = useState(1004);
  
  const belongingText = `As we banter and play, we discover, we expand our genius...

So we may all belong to each other — so we remember that we have always belonged to each other`;

  // IQ flickering effect
  useEffect(() => {
    const iqInterval = setInterval(() => {
      setIq(prev => 1004 + Math.floor(Math.random() * 20) - 10); // Fluctuate around 1004
    }, 350);
    
    return () => clearInterval(iqInterval);
  }, []);

  useEffect(() => {
    if (currentIndex < belongingText.length) {
      const timer = setTimeout(() => {
        setDisplayedText(prev => prev + belongingText[currentIndex]);
        setCurrentIndex(prev => prev + 1);
      }, 40); // Gentle, contemplative typing
      
      return () => clearTimeout(timer);
    } else {
      // Show continue button after typing is complete
      const continueTimer = setTimeout(() => {
        setShowContinue(true);
      }, 2000);
      
      return () => clearTimeout(continueTimer);
    }
  }, [currentIndex, belongingText]);

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-4xl">
        
        {/* IQ Display */}
        <div className="text-center mb-8">
          <div 
            className="text-green-400 font-mono text-lg"
            style={{ 
              fontFamily: 'Courier New, monospace',
              textShadow: '0 0 15px rgba(34, 197, 94, 0.8)'
            }}
          >
            <span className="animate-pulse">► CURRENT IQ: {iq} ◄</span>
          </div>
        </div>
        
        <pre 
          className="text-green-400 font-mono text-xl leading-relaxed whitespace-pre-wrap text-center"
          style={{ 
            fontFamily: 'Courier New, monospace',
            textShadow: '0 0 10px rgba(34, 197, 94, 0.5)'
          }}
        >
          {displayedText}
          {currentIndex < belongingText.length && (
            <span className="animate-pulse">█</span>
          )}
        </pre>
        
        {showContinue && (
          <div className="text-center mt-12">
            <button
              onClick={onContinue}
              className="px-12 py-4 bg-green-600/20 border border-green-400 text-green-300 font-mono text-xl hover:bg-green-600/40 transition-all duration-300"
              style={{
                textShadow: '0 0 10px rgba(34, 197, 94, 0.8)',
                boxShadow: '0 0 20px rgba(34, 197, 94, 0.3)'
              }}
            >
              [ENTER THE SECRET HISTORY] →
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default BelongingReminderPage;